import { IThemeColors } from '@wyz/types';
import { COMPUTED_PRICING_POLICY_STATUS } from '~/common/schemas';
import { TranslationKeys } from '~/common/types';

export const getStatusOptions = (): Array<{
  value: keyof typeof COMPUTED_PRICING_POLICY_STATUS;
  label: keyof TranslationKeys;
}> => [
  {
    value: COMPUTED_PRICING_POLICY_STATUS.DRAFT,
    label: 'app.common.status.draft',
  },
  {
    value: COMPUTED_PRICING_POLICY_STATUS.ACTIVE,
    label: 'app.purchase.pricing_policy.status.active',
  },
  {
    value: COMPUTED_PRICING_POLICY_STATUS.UPCOMING,
    label: 'app.common.status.upcoming',
  },
  {
    value: COMPUTED_PRICING_POLICY_STATUS.EXPIRED,
    label: 'app.common.status.expired',
  },
];

export const PRICING_COMPUTED_STATUS_LOOKUP: Record<
  keyof typeof COMPUTED_PRICING_POLICY_STATUS,
  IThemeColors
> = {
  ACTIVE: 'success',
  DRAFT: 'warning',
  DISABLED: 'danger',
  EXPIRED: 'danger',
  UPCOMING: 'info',
};
